import React from "react";
import GenericPullConfigListing from "../GenericPullConfigListing";
import RiskReconMappingForm from "./RiskReconMappingForm";
import RiskReconCredentialsForm from "./RiskReconCredentialsForm";

export default function RiskReconConfigListing(props){
    return (
        <GenericPullConfigListing 
            {...props}
            toolName={props.name}
            MappingForm={RiskReconMappingForm}
            CredentialsForm={RiskReconCredentialsForm}
            componentName="Company Name"
            componentKey="companyName"

        />
    )
}